export default "/Frontend/dist/word.ef2831dce185e810e628a7466accde43.svg";